export default __webpack_public_path__ + "images/erickson-living-main.svg?85765e4da4362062814630216d07c539";